import { observer } from 'mobx-react-lite';
import dynamic from 'next/dynamic';

import { IScrollTopButtonProps } from 'ati-ui-react/components/ScrollTopButton';

import { scrollTopAnchorId } from 'constants/ui';
import { useStore } from 'hooks/useStore';
import { scrollTo } from 'utils/nativeDOM';

import css from './ScrollTopButton.module.css';

const ScrollTopButtonUI = dynamic<IScrollTopButtonProps>(
  () => import('ati-ui-react/components/ScrollTopButton').then(mod => mod.default),
  {
    ssr: false,
  },
);

const ScrollTopButton = () => {
  const { ui } = useStore();

  const handleClick = () => {
    scrollTo(`#${scrollTopAnchorId}`, { block: 'start' });
  };

  return (
    <div className={css.container}>
      {ui.isSticky && <ScrollTopButtonUI className={css.button} onClick={handleClick} />}
    </div>
  );
};

const connected = observer(ScrollTopButton);

export { connected as ScrollTopButton };
